import { Product, Variant } from '../domain';

export const getProductImageAspectRatio = (
  variant?: Pick<Variant, 'featured_image'> | null,
  product?: Pick<Product, 'media' | 'featured_image'> | null,
): string => {
  const defaultAspectRatio = '1';

  if (variant?.featured_image) return variant.featured_image.aspect_ratio;

  if (!product || !product.featured_image) return defaultAspectRatio;

  const featuredImage = product.media?.find(
    (imageMedia) => imageMedia.src === `https:${product.featured_image}`,
  );

  return featuredImage?.aspect_ratio || defaultAspectRatio;
};
